export enum NotificationType {
  NEW_MATCH = 'New Match',
  DUPLICATE = 'Duplicate',
  INVITED_APPLIED = 'InvitedApplied',
  HIRING_MANAGER = 'HiringManager',
  REFERRAL = 'Referral',
  ASSIGN = 'Assign',
}

export interface BaseNotification {
  id: number;
  itemType?: string;
  itemId?: number;

  /**
   * Time in UTC when notification was created.
   */
  createdDate: Date;
  isRead?: boolean;
}

export interface HiringManagerNotification extends BaseNotification {
  type: NotificationType.HIRING_MANAGER;
  data: {
    /** candidate display name */
    candName: string;
    candidateId: string;
    anonymizedName?: string; // candidate's anonymized name
    hiringManagerName: string;
    initials: string;
    label?: string;
    displayAnonymized?: boolean;
    jobName: string;
    status: string;
  };
}

export interface DuplicateNotification extends BaseNotification {
  type: NotificationType.DUPLICATE;
  data: {
    /** candidate display name */
    name: string;
    anonymizedName?: string; // candidate's anonymized name
    imageId: number;
    initials: string;
    label?: string;
    displayAnonymized?: boolean;
  };
}

export interface ReferralNotification extends BaseNotification {
  type: NotificationType.REFERRAL;
  data: {
    /** candidate display name */
    candidateName: string;
    anonymizedName?: string;
    imageId: number;
    initials: string;
    label?: string;
    displayAnonymized?: boolean;
    jobTitle: string;
    jobId: number;
  };
}

export interface NewMatchNotification extends BaseNotification {
  type: NotificationType.NEW_MATCH;
  data: {
    imageId: number;
  };
}

/** when candidate who was invited to apply has applied and became direct applicant */
export interface InvitedAppliedNotification extends BaseNotification {
  type: NotificationType.INVITED_APPLIED;
  data: {
    // all the data in db is stored as json with only string values
    candidateId: string;
    name: string; // candidate's name
    anonymizedName: string; // candidate's anonymized name
    jobId: string;
    jobTitle: string;
    recruiterId: string; // id of user who clicked invite button
    imageId: string;
    initials: string;
    label?: string; // hot/warm/cold
    displayAnonymized?: boolean;
  };
}

export type Notification =
  | DuplicateNotification
  | NewMatchNotification
  | InvitedAppliedNotification
  | HiringManagerNotification
  | ReferralNotification;
